export const CURRENCY_SYMBOL = { TRY: "₺", USD: "$", EUR: "€", GBP: "£" };

export function fmtMoney(amount, currency = "TRY") {
  const n = Number(amount || 0);
  const s = new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
  return `${s} ${CURRENCY_SYMBOL[currency] || currency}`;
}

// Render a balances dict {TRY:"...",USD:"..."} — only non-zero, TRY always shown
export function balanceEntries(balances = {}) {
  const entries = Object.entries(balances).filter(([, v]) => Number(v) !== 0);
  if (entries.length === 0) return [["TRY", "0"]];
  return entries;
}

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
    return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export const STATUS_META = {
  NORMAL: { label: "Normal", cls: "bg-emerald-100 text-emerald-700" },
  DUSUK: { label: "Düşük Avans", cls: "bg-amber-100 text-amber-800" },
  AVANS_TUKENDI: { label: "Avans Tükendi", cls: "bg-brand-redbg text-brand-red" },
};

export const ROLE_LABEL = { admin: "Yönetici", lawyer: "Avukat", accountant: "Muhasebe" };
